import { render, staticRenderFns } from "./TaxInvoiceStatus.vue?vue&type=template&id=37fe7ddc&scoped=true"
import script from "./TaxInvoiceStatus.vue?vue&type=script&lang=js"
export * from "./TaxInvoiceStatus.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoiceStatus.vue?vue&type=style&index=0&id=37fe7ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe7ddc",
  null
  
)

export default component.exports